export default __webpack_public_path__ + "static/media/portfolio-69.64ba8b56.jpg";